document.addEventListener('DOMContentLoaded', function () {
    const buyNowButtons = document.querySelectorAll('.quick-add__submit.quick-add__submit_btn');
    const radioElements = document.querySelectorAll('input[name="Mount_Type1"]'); // Select all radios with the same name
    const tabbtns = document.querySelectorAll('.shades_options_tabsbtn');
    const tabcontnt = document.querySelectorAll('.shades_options_tabcontent');

    // Ensure that the first tab and content are active and visible initially
    if (tabbtns.length > 0 && tabcontnt.length > 0) {
        // Add 'active' class to the first tab button
        tabbtns[0].classList.add('active');
        
        // Display the first tab content
        tabcontnt[0].style.display = 'block';
    }

    if (buyNowButtons.length > 0) {
        buyNowButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                // Deselect all radio buttons
                if (radioElements.length > 0) {
                    radioElements.forEach(function (radio) {
                        console.log('Deselecting:', radio); // Debug: Log the radio being deselected
                        radio.checked = false; // Deselect each radio button
                    });
                } else {
                    console.error('No radio buttons found with the name "Mount_Type1".');
                }

                // Remove 'active' class from all tab buttons
                if (tabbtns.length > 0) {
                    tabbtns.forEach(function (tab) {
                        tab.classList.remove('active');
                    });
                }

                // Hide all tab contents
                if (tabcontnt.length > 0) {
                    tabcontnt.forEach(function (tab) {
                        tab.style.display = 'none';
                    });
                }

                // Add 'active' class to the first tab and display the first tab content
                if (tabbtns.length > 0 && tabcontnt.length > 0) {
                    tabbtns[0].classList.add('active');
                    tabcontnt[0].style.display = 'block';
                }
            });
        });
    } else {
        console.error('No Buy Now buttons found.');
    }
});
